module.exports = __webpack_public_path__ + "static/media/participles6_img.2fcca2f9.JPG";